import React from 'react';
import MediaQueries from 'react-responsive';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaMultipleImages from 'marketing-website/components/modules/Media/MediaMultipleImages';
import ParallaxWrapper from 'marketing-website/components/wrappers/ParallaxWrapper';
import Pattern from 'marketing-website/components/commons/Pattern';
import Shape from 'marketing-website/components/commons/Shape';

import assets from 'marketing-website/configs/pages/features/handoff/assets.js';

export default function Code() {
  return (
    <PageWrap size="l">
      <Spacing size="xl" type="padding" position="topBottom">
        <Grid columns={12}>
          <GridItem columnSpan={12} columnSpanM={6} alignContent="center">
            <MediaQueries minWidth={770}>
              <HeadingBlock
                justifyContent="center"
                maxWidth={430}
                title="Export code as CSS, Swift and Android XML"
                copy={
                  <span>
                    Whether you've designed mockups in Sketch or within the
                    Marvel design tool, you can generate the code you need to
                    take a prototype from design to development.
                    <br />
                    <br />
                    With one click, you can download assets and copy the CSS,
                    Swift and Android XML code for your prototype - simplifying
                    your entire design developer handoff process.
                  </span>
                }
              />
            </MediaQueries>
          </GridItem>
          <GridItem columnSpan={12} columnSpanM={6} alignContent="center">
            <MediaMultipleImages
              fallbackImageAlt={assets.cssFallback.alt}
              fallbackImageSrc={assets.cssFallback.src}
              fallbackImageMaxWidth={assets.cssFallback.maxWidth}
            >
              <ParallaxWrapper>
                <Shape type="square" color="lightGreen" top="35%" left="20%" />
                <Pattern type="fish" color="green" top="70%" left="36%" />
              </ParallaxWrapper>
              <ParallaxWrapper>
                <div className="opacity-50">
                  <Image
                    {...assets.backPanel}
                    hasShadow={false}
                    left="15%"
                    top="5%"
                    maxWidth={242}
                    position="absolute"
                  />
                </div>
              </ParallaxWrapper>
              <ParallaxWrapper speed={1.2}>
                <Image
                  {...assets.designWatch}
                  maxWidth={240}
                  position="absolute"
                  top="32%"
                  left="5%"
                  borderRadius="m"
                />
              </ParallaxWrapper>
              <ParallaxWrapper speed={2}>
                <Image
                  {...assets.cssPanel}
                  borderRadius="m"
                  left="32%"
                  maxWidth={300}
                  position="absolute"
                  top="20%"
                />
              </ParallaxWrapper>
            </MediaMultipleImages>
            <MediaQueries maxWidth={769}>
              <Spacing size="l" type="margin" position="top">
                <HeadingBlock
                  justifyContent="center"
                  maxWidth={430}
                  title="CSS, Swift and Android XML code"
                  copy="Grab the measurements, typography and colours in one click. Your developers will love how easy this is."
                />
              </Spacing>
            </MediaQueries>
          </GridItem>
        </Grid>
      </Spacing>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/handoff/Code.js